import { selectors, useAppSelector } from 'state/global-state';

import type { LoyaltyUser } from './types';

export const useLoyaltyUser = (): { loyaltyUser: LoyaltyUser | null; loading: boolean } =>
  useAppSelector(selectors.loyalty.selectLoyaltyUser);
